module.exports = require('./helpers/bundle-url').getBundleURL('2LpMj') + "calendar_before_dark.e7d25cf9.png" + "?" + Date.now();